// Generated by ts-to-zod
import { z } from 'zod';
import { queueRuleSchema } from '../models/queueRule.schema';

export const ruleCreatePayloadSchema = queueRuleSchema.omit({
  id: true,
  url: true,
});
